// This file is automatically generated. Do not edit manually.

import { PartConfigurationProperty } from "src/api/generated/erp/db/types/tables/partConfigurationProperty";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PartConfigurationApi {
	export async function getPartConfigurationWorkInstructions(args: { partConfigurationId: number }): Promise<string> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuration/getPartConfigurationWorkInstructions",
			method: "POST",
			data: {
				partConfigurationId: args.partConfigurationId,
			},
		});
		return response as string;
	}

	export async function getPartConfigurationProperties(args: {
		partConfigurationId: number;
		searchQuery?: string;
	}): Promise<Array<PartConfigurationProperty>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/configuration/getPartConfigurationProperties",
			method: "POST",
			data: {
				partConfigurationId: args.partConfigurationId,
				searchQuery: args.searchQuery,
			},
		});
		return response as Array<PartConfigurationProperty>;
	}
}
